import {StoreState} from '@/app/store';

export const selectDeviceCoordinates = (state: StoreState) => state.geolocation.coordinates;
export const selectDeviceGeolocationSettlement = (state: StoreState) => state.geolocation.exactSettlement;
export const selectDeviceGeneralSettlement = (state: StoreState) => state.geolocation.generalSettlement;
export const selectDeviceGeolocationOrGeneralSettlement = (state: StoreState) =>
	state.geolocation.exactSettlement || state.geolocation.generalSettlement;
